var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"t-delimiter",class:{ 't-delimiter--vertical': _vm.vertical }})
}
var staticRenderFns = []

export { render, staticRenderFns }